import React from 'react';

interface FupAndProps {
  width?: number;
  height?: number;
}

const FupAnd: React.FC<FupAndProps> = ({ width = 80, height = 60 }) => (
  <svg width={width} height={height} viewBox="0 0 80 60" xmlns="http://www.w3.org/2000/svg">
    {/* Baustein-Körper */}
    <rect x="5" y="10" width="40" height="40" fill="#E8F4F8" stroke="#0D3559" strokeWidth="2" />
    {/* Rechteckiger Teil links */}
    <path d="M 45 10 L 45 50 Q 70 30 45 10" fill="#E8F4F8" stroke="#0D3559" strokeWidth="2" />
    
    {/* Eingangs-Ankerpunkte */}
    <circle cx="5" cy="20" r="3" fill="#0D3559" />
    <circle cx="5" cy="40" r="3" fill="#0D3559" />
    
    {/* Ausgangs-Ankerpunkt */}
    <circle cx="75" cy="30" r="3" fill="#0D3559" />
    
    {/* Label */}
    <text x="25" y="35" fontSize="12" fill="#0D3559" textAnchor="middle" fontWeight="bold">&amp;</text>
  </svg>
);

export default FupAnd;
